import React, { Component } from 'react';
import CanvasJSReact from '@canvasjs/react-charts';

var CanvasJSChart = CanvasJSReact.CanvasJSChart;

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalTokens: 0,
      soldTokens: 0,
      unsoldTokens: 0,
      salePercentage: 0,
      currentStageTitle: '', // Add a state for the current stage title
    };
  }

  componentDidMount() {
    this.fetchStageData();
    this.fetchOrderData();
  }

 fetchStageData = async () => {
  try {
    const token = localStorage.getItem('token'); // Get token from localStorage
    
    const response = await fetch(`${process.env.REACT_APP_API_URL}/stages`, {
      headers: {
        'Authorization': `Bearer ${token}`, // Add Authorization header
        'Content-Type': 'application/json',
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    console.log('Tokenomics data:', data);
    
    // Handle new tokenomics structure
    if (data.tokenomics && data.tokenomics.length > 0) {
      const currentTokenomics = data.tokenomics.find(item => item.isCurrent === true) || data.tokenomics[0];
      
      this.setState({
        totalTokens: parseFloat(currentTokenomics.tokensToSell),
        currentStageTitle: `Stage ${currentTokenomics.stage}`,
      });
    } else if (data.stages) {
      // Fallback to old structure if tokenomics not available
      const currentDate = new Date();
      const currentStage = data.stages.find(stage => {
        const startDate = new Date(stage.start_date);
        const endDate = new Date(stage.end_date);
        return currentDate >= startDate && currentDate <= endDate;
      });

      if (currentStage) {
        this.setState({
          totalTokens: parseFloat(currentStage.total_tokens),
          currentStageTitle: currentStage.title,
        });
      }
    }
  } catch (error) {
    console.error('Error fetching stages data:', error);
    // Optional: Handle authentication errors specifically
    if (error.message.includes('401') || error.message.includes('403')) {
      console.error('Authentication failed. Redirecting to login...');
      // You might want to redirect to login page or clear token here
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
  }
};

  fetchOrderData = async () => {
    try {
     const token = localStorage.getItem('token'); // Get token from localStorage
    
    const response = await fetch(`${process.env.REACT_APP_API_URL}/stages`, {
      headers: {
        'Authorization': `Bearer ${token}`, // Add Authorization header
        'Content-Type': 'application/json',
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
      
      // Fetch the current tokenomics data
      const tokenomicsResponse = await fetch(`${process.env.REACT_APP_API_URL}/stages`);
      const tokenomicsData = await tokenomicsResponse.json();
      
      let soldTokens = 0;
      let unsoldTokens = 0;
      let salePercentage = 0;

      // Handle new tokenomics structure
      if (tokenomicsData.tokenomics && tokenomicsData.tokenomics.length > 0) {
        const currentTokenomics = tokenomicsData.tokenomics.find(item => item.isCurrent === true) || tokenomicsData.tokenomics[0];
        
        soldTokens = parseFloat(currentTokenomics.tokensSold) || 0;
        unsoldTokens = parseFloat(currentTokenomics.tokensToSell) - soldTokens;
        salePercentage = (soldTokens / parseFloat(currentTokenomics.tokensToSell)) * 100;
      } else if (tokenomicsData.stages) {
        // Fallback to old structure
        const currentDate = new Date();
        const currentStage = tokenomicsData.stages.find(stage => {
          const startDate = new Date(stage.start_date);
          const endDate = new Date(stage.end_date);
          return currentDate >= startDate && currentDate <= endDate;
        });

        if (currentStage) {
          const currentStageStartDate = new Date(currentStage.start_date);
          const currentStageEndDate = new Date(currentStage.end_date);

          // Calculate sold tokens by summing tokens for orders within the stage date range
          soldTokens = data.orders.reduce((sum, order) => {
            const orderDate = new Date(order.created_at);
            if (orderDate >= currentStageStartDate && orderDate <= currentStageEndDate) {
              return sum + parseFloat(order.tokens);
            }
            return sum;
          }, 0);

          // Calculate unsold tokens
          unsoldTokens = this.state.totalTokens - soldTokens;

          // Calculate sale percentage
          salePercentage = (soldTokens / this.state.totalTokens) * 100;
        }
      }

      this.setState({
        soldTokens,
        unsoldTokens,
        salePercentage,
      });
    } catch (error) {
      console.error('Error fetching orders data:', error);
    }
  };

  render() {
    const { totalTokens, soldTokens, unsoldTokens, salePercentage, currentStageTitle } = this.state;
    const options = {
      animationEnabled: true,
      theme: "dark1",
      backgroundColor: "transparent",
      subtitles: [{
        text: `${totalTokens.toLocaleString()}`,
        verticalAlign: "center",
        fontSize: 24,
        dockInsidePlotArea: true,
        fontColor: "#fff",
      }],
      data: [{
        type: "doughnut",
        innerRadius: "70%", // Increase the innerRadius to make the hole larger
        radius: "90%",     // Increase radius to make the outer edge thicker
        showInLegend: true,
        indexLabel: "{name}: {y}",
        yValueFormatString: "#,###",
        indexLabelFontColor: "#fff",
        indexLabelLineColor: "#fff",
        lineThickness: 2,
        shadow: true,
        shadowColor: "#000",
        shadowBlur: 10,
        dataPoints: [
          { name: "Total", y: totalTokens, color: "#FF6347" },
          { name: "Sold", y: soldTokens, color: "#32CD32" },
          { name: "Sale", y: salePercentage, color: "#FFD700" },
          { name: "UnSold", y: unsoldTokens, color: "#A9A9A9" },
        ],
        animationDuration: 1500,
        animationEasing: "easeOutBounce",
      }],
      legend: {
        cursor: "pointer",
        itemclick: function(e) {
          if (typeof(e.dataSeries.visible) === "undefined" || e.dataSeries.visible) {
            e.dataSeries.visible = false;
          } else {
            e.dataSeries.visible = true;
          }
          e.chart.render();
        },
        itemFontColor: "#fff",
        itemHoverStyle: { fontColor: "#FF6347" },
        itemFontSize: 16,
      },
      plotAreaBorderColor: "#333",
      borderColor: "#333",
      borderThickness: 2,
      toolTip: {
        shared: true,
        backgroundColor: "#222",
        contentFormatter: function(e) {
          return `${e.entries[0].dataPoint.name}: ${e.entries[0].dataPoint.y}%`;
        },
      },
      padding: {
        top: 10,
        right: 10,
        bottom: 10,
        left: 10,
      },
    };

    return (
      <div style={{
        padding: '30px', 
        backgroundColor: 'black',
        borderRadius: '15px',
        boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.6)',
      }}>
        <h1 style={{
          width: '100%',
          color: '#fff',
          fontSize: '30px',
          fontWeight: 'bold',
          paddingBottom: '20px',
        }}>
          {currentStageTitle || 'Loading...'} {/* Display current stage title */}
        </h1>
        <CanvasJSChart options={options} />
      </div>
    );
  }
}

export default App;
